export default "__VITE_ASSET__B$mPbx4w__"